var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"my-auto photo ui image",attrs:{"id":'card_' + _vm.photo.id,"src":_vm.photoSrc},on:{"mousedown":_vm.start,"mouseleave":_vm.stop,"mouseup":_vm.stop,"touchstart":_vm.start,"touchend":_vm.stop,"touchcancel":_vm.stop,"click":function($event){$event.stopPropagation();return _vm.$emit('gallery', _vm.photo.id)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }